import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=7c612f65&"
import script from "./comment.vue?vue&type=script&lang=ts&"
export * from "./comment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c612f65')) {
      api.createRecord('7c612f65', component.options)
    } else {
      api.reload('7c612f65', component.options)
    }
    module.hot.accept("./comment.vue?vue&type=template&id=7c612f65&", function () {
      api.rerender('7c612f65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/microblog/comment.vue"
export default component.exports